"use strict";

(function () {
    jQuery(document).ready(function () {
        initOnlyNumberInput();
    });
})(jQuery);

function initOnlyNumberInput() {
    $('.onlyNumberInput').on('input', function () {
        let inputValue = $(this).val();
        let sanitizedInput = inputValue.replace(/[^0-9]/g, '');
        $(this).val(sanitizedInput);
    });
}